import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContractDigitizationRoutingModule } from './contract-digitization-routing.module';
import { ContractDigitizationComponent } from './contract-digitization.component';
import { ListContractDigitizationComponent } from './list-contract/list-contract.component';
import { AddContractDigitizationComponent } from './add-contract/add-contract.component';
import {SharedModule} from '../../../../../../shared/shared.module';
import {TranslateModule} from '@ngx-translate/core';
import { FilterContractDigitizationComponent } from './filter-contract-digitization/filter-contract-digitization.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
    NzAutocompleteModule,
    NzDatePickerModule,
    NzIconModule,
    NzInputModule,
    NzPopconfirmModule,
    NzSpinModule, NzTableModule, NzTagModule, NzToolTipModule
} from 'ng-zorro-antd';
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';
import { ViewContractComponent } from './view-contract/view-contract.component';
import {NgMatAutocompleteModule} from '../../../../../../shared/components/autocomplete/autocomplete.module';
import { UploadMultiFileAttachmentsComponent } from './upload-multi-file-attachments/upload-multi-file-attachments.component';


@NgModule({
  declarations: [ContractDigitizationComponent, ListContractDigitizationComponent, AddContractDigitizationComponent, FilterContractDigitizationComponent, ViewContractComponent, UploadMultiFileAttachmentsComponent],
    imports: [
        CommonModule,
        SharedModule,
        ContractDigitizationRoutingModule,
        TranslateModule,
        ReactiveFormsModule,
        NzDatePickerModule,
        NgxExtendedPdfViewerModule,
        NgMatAutocompleteModule,
        FormsModule,
        NzAutocompleteModule,
        NzIconModule,
        NzInputModule,
        NzPopconfirmModule,
        NzSpinModule,
        NzTableModule,
        NzToolTipModule,
        NzTagModule
    ],
    entryComponents: [ViewContractComponent, UploadMultiFileAttachmentsComponent]
})
export class ContractDigitizationModule { }
